import dayjs from 'dayjs'

import { DateTimeCustomOption } from '@makyoapp/makyo-common'

export function parseVariableDateTime(value: DateTimeCustomOption, dateUpperEnd = false) {
  let dateVal: dayjs.Dayjs | undefined

  const now = dayjs()

  switch (value) {
    case DateTimeCustomOption.Now:
      dateVal = now
      break
    case DateTimeCustomOption.Today:
      dateVal = dateUpperEnd ? now.endOf('day') : now.startOf('day')
      break
    case DateTimeCustomOption.Tomorrow:
      dateVal = dateUpperEnd ? now.add(1, 'day').endOf('day') : now.add(1, 'day').startOf('day')
      break
    case DateTimeCustomOption.Yesterday:
      dateVal = dateUpperEnd ? now.subtract(1, 'day').endOf('day') : now.subtract(1, 'day').startOf('day')
      break
    case DateTimeCustomOption.CurrentMonth:
      dateVal = now.startOf('month')
      break
    case DateTimeCustomOption.LastMonth:
      dateVal = now.subtract(1, 'month').startOf('month')
      break
    case DateTimeCustomOption.NextMonth:
      dateVal = now.add(1, 'month').startOf('month')
      break
    case DateTimeCustomOption.CurrentYear:
      dateVal = now.startOf('year')
      break
    case DateTimeCustomOption.LastYear:
      dateVal = now.subtract(1, 'year').startOf('year')
      break
    case DateTimeCustomOption.NextYear:
      dateVal = now.add(1, 'year').startOf('year')
      break
  }

  return dateVal?.toISOString()
}
